import { createSlice } from '@reduxjs/toolkit';

import { handleGetAthleteSports } from './actions';
import { IAthleteSportsState } from './slice.interface';

const initialState: IAthleteSportsState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const athleteSportsSlice = createSlice({
  name: 'athlete-sports',
  initialState,
  reducers: {
    removeAthleteSports: (state: IAthleteSportsState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAthleteSports.pending, (state: IAthleteSportsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetAthleteSports.rejected, (state: IAthleteSportsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetAthleteSports.fulfilled, (state: IAthleteSportsState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeAthleteSports } = athleteSportsSlice.actions;

export default athleteSportsSlice.reducer;
